<template>
    <div>
        <fusioncharts
            type="column2d"
            width="100%"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: [Array, Object],
                required: true,
            },

            bgColor: {
                type: String,
                default: "transparent"
            },
            
            height: {
                type: [Number, String],
                default: 270
            },

            legendFontColor: {
                type: String,
                default: "#ffffff"
            },

            labelFontColor: {
                type: String,
                default: "#ffffff"
            },

            showValues: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                paletteColors: [
                    '3b82f6',
                    '22c55e',
                ]
            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        paletteColors: this.paletteColors.join(','),
                        bgColor: 'FFFFFF',
                        bgAlpha: '0',
                        canvasBgColor: 'FFFFFF',
                        canvasBgAlpha: '0',
                        showBorder: '0',
                        showCanvasBorder: '0',
                        usePlotGradientColor: '0',
                        baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
                        baseFontSize: 13,
                        caption: "",
                        showValues: this.showValues,
                        valueFontSize: 12,
                        labelFontColor: this.labelFontColor,
                        labelFontBold: "0",
                        plotToolText: "<b>$label</b>: $dataValue",
                        showLegend: "1",
                        legendPosition: "bottom",
                        legendItemFontSize: 13,
                        legendItemFontColor: this.legendFontColor,
                        legendIconScale: ".8",
                        legendItemFontBold: "0",
                        showYAxisValues: "1",
                        yAxisName: "",
                        xAxisName: "",
                        yAxisValueFontSize: "12",
                        yAxisValueFontBold: "0",
                        xAxisNameFontSize: "12",
                        xAxisNameFontBold: "0",
                        placeValuesInside: "0",
                        rotateValues: "0",
                        chartLeftMargin: "20",
                        chartRightMargin: "20",
                        chartTopMargin: "10",
                        chartBottomMargin: "10",
                        containerBackgroundOpacity: "0",
                        divLineAlpha: "20",
                        divLineColor: this.labelFontColor,
                        divLineThickness: "1",
                        divLineIsDashed: "0"
                    },
                    data: this.data
                }
            }
        },
    }
</script>
